// NOTE: (3) just a class to signal events.
import { debounceTime, distinctUntilChanged, map, publishReplay, refCount, scan, startWith } from "rxjs/operators";
import { Subject } from "rxjs";
export class LoadingService {
    constructor() {
        this._loadersSubject$ = new Subject();
        this._loaders$ = this._loadersSubject$.pipe(scan((loaders, loader) => {
            if (loader.task !== undefined) {
                loaders[loader.task] = loader.loading;
            }
            return loaders;
        }, {}), startWith({}), publishReplay(1), refCount());
    }
    get loading$() {
        return this._loaders$.pipe(map((loaders) => {
            for (const key in loaders) {
                if (!Object.prototype.hasOwnProperty.call(loaders, key)) {
                    continue;
                }
                if (loaders[key]) {
                    return true;
                }
            }
            return false;
        }), debounceTime(100), distinctUntilChanged());
    }
    taskLoading$(task) {
        return this._loaders$.pipe(map((loaders) => {
            return !!loaders[task];
        }), debounceTime(100), distinctUntilChanged());
    }
    startLoading(task) {
        this._loadersSubject$.next({ loading: true, task: task });
    }
    stopLoading(task) {
        this._loadersSubject$.next({ loading: false, task: task });
    }
}
//# sourceMappingURL=LoadingService.js.map